import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_API_URL;

const ProfileModal = ({ isOpen, onClose }) => {
  const [user, setUser] = useState({});
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
 const navigate = useNavigate();
const handleLogout = () => {
  navigate("/admin/login");
  localStorage.removeItem("admin");
};
  useEffect(() => {
    if (!isOpen) return; // Fetch only when modal is open

    const fetchUser = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const response = await fetch(`${base_url}/api/webapi/fetchUser`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        const data = await response.json();
        // console.log("Fetched user data:", data);
        setUser(data);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    fetchUser();
  }, [isOpen]);

  // Function to update user
  const handleUpdate = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const auth = localStorage.getItem("admin");
      const response = await fetch(`${base_url}/api/webapi/updateUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
        body: JSON.stringify({
          id_user: user.id_user,
          password: newPassword,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update user");
      }

      toast.success("User updated successfully!");
      handleLogout()
      setNewPassword("");
      setConfirmPassword("");

    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Error updating user");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "50px",
        right: isOpen ? "0px" : "-350px",
        width: "350px",
        height: "100vh",
        backgroundColor: "#343A40",
        zIndex: 1000,
        color: "#fff",
        padding: "15px",
        transition: "right 0.3s ease-in-out",
        borderRadius: "10px 0 0 10px",
        boxShadow: isOpen ? "0 0 10px rgba(255,255,255,0.3)" : "none",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h2 style={{ margin: 0 }}>MY PROFILE</h2>
        <button
          onClick={onClose}
          style={{
            background: "red",
            border: "none",
            color: "#fff",
            fontSize: "16px",
            cursor: "pointer",
            padding: "5px 10px",
          }}
        >
          ✖
        </button>
      </div>

      {/* Profile Form */}
      <label>User Id</label>
      <input
        type="text"
        value={user.id_user || ""}
        name="userid"
        readOnly
        style={{
          color: "#000",
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "none",
        }}
      />

      <label>User Name</label>
      <input
        type="text"
        value={user.username || ""}
        name="username"
        readOnly
        style={{
          color: "#000",
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "none",
        }}
      />

      <label>Role</label>
      <input
        type="text"
        value={user.role}
        readOnly
        style={{
          color: "#000",
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "none",
        }}
      />

      <label>Old Password</label>
      <input
        type="text"
        value={user.plain_password}
        readOnly
        style={{
          color: "#000",
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "none",
        }}
      />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "48%" }}>
          <label>New Password</label>
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{
              color: "#000",
              width: "100%",
              padding: "8px",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
            }}
          />
        </div>
        <div style={{ width: "48%" }}>
          <label>Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              color: "#000",
              width: "100%",
              padding: "8px",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
            }}
          />
        </div>
      </div>

      {/* Update Button */}
      <button
        onClick={handleUpdate}
        style={{
          width: "100%",
          padding: "10px",
          backgroundColor: "red",
          color: "#fff",
          fontSize: "16px",
          cursor: "pointer",
          borderRadius: "5px",
          border: "none",
          marginTop: "10px",
        }}
      >
        UPDATE
      </button>
    </div>
  );
};

export default ProfileModal;